var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "91px",
    viewBox: "0 0 91 91",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.8333 0C38.3981 0 39.6667 1.26853 39.6667 2.83333C39.6667 4.28637 38.5729 5.48394 37.1638 5.6476L36.8333 5.66667L5.66667 5.66667L5.66667 11.3333L62.3333 11.3333L62.3333 5.66667L59.5 5.66667C58.047 5.66667 56.8494 4.57289 56.6857 3.16376L56.6667 2.83333C56.6667 1.3803 57.7604 0.18273 59.1696 0.0190619L59.5 0L65.1667 0C66.6197 0 67.8173 1.09378 67.9809 2.50291L68 2.83333L68 14.1667C68 15.6197 66.9062 16.8173 65.4971 16.9809L65.1667 17L2.83333 17C1.3803 17 0.18273 15.9062 0.0190619 14.4971L0 14.1667L0 2.83333C0 1.3803 1.09378 0.18273 2.50291 0.0190619L2.83333 0L36.8333 0Z",
    transform: "translate(11 6)",
    id: "Path",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1667 0L2.83333 0C1.26853 0 0 1.26853 0 2.83333L0 14.1667C0 15.7315 1.26853 17 2.83333 17L65.1667 17C66.7315 17 68 15.7315 68 14.1667L68 2.83333C68 1.26853 66.7315 0 65.1667 0ZM62.3333 5.66667L62.3333 11.3333L5.66667 11.3333L5.66667 5.66667L62.3333 5.66667Z",
    transform: "translate(11 67)",
    id: "Path-22-Copy",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0C22.9856 0 28 5.14873 28 11.5C28 17.6588 23.2849 22.6869 17.359 22.9859L16.8 23L10.2 23C6.33401 23 3.2 19.782 3.2 15.8125C3.2 12.0017 6.0883 8.88364 9.73975 8.64029L10.2 8.625L15.6 8.625C17.1464 8.625 18.4 9.91218 18.4 11.5C18.4 12.9744 17.3191 14.1896 15.9265 14.3557L15.6 14.375L10.2 14.375C9.4268 14.375 8.8 15.0186 8.8 15.8125C8.8 16.5182 9.29525 17.1051 9.94835 17.2268L10.2 17.25L16.8 17.25C19.8928 17.25 22.4 14.6756 22.4 11.5C22.4 8.46871 20.1155 5.98528 17.2179 5.76577L16.8 5.75L2.8 5.75C1.2536 5.75 0 4.46282 0 2.875C0 1.4006 1.08091 0.185417 2.47346 0.0193422L2.8 0L16.8 0Z",
    transform: "translate(51 25)",
    id: "Path-24",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 0C22.9856 0 28 5.14873 28 11.5C28 17.6588 23.2849 22.6869 17.359 22.9859L16.8 23L10.2 23C6.33401 23 3.2 19.782 3.2 15.8125C3.2 12.0017 6.0883 8.88364 9.73975 8.64029L10.2 8.625L15.6 8.625C17.1464 8.625 18.4 9.91218 18.4 11.5C18.4 12.9744 17.3191 14.1896 15.9265 14.3557L15.6 14.375L10.2 14.375C9.4268 14.375 8.8 15.0186 8.8 15.8125C8.8 16.5182 9.29525 17.1051 9.94835 17.2268L10.2 17.25L16.8 17.25C19.8928 17.25 22.4 14.6756 22.4 11.5C22.4 8.46871 20.1155 5.98528 17.2179 5.76577L16.8 5.75L2.8 5.75C1.2536 5.75 0 4.46282 0 2.875C0 1.4006 1.08091 0.185417 2.47346 0.0193422L2.8 0L16.8 0Z",
    transform: "matrix(-1 0 0 1 39 25)",
    id: "Path-24",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 25.2C6 26.7464 4.65685 28 3 28C1.46149 28 0.193479 26.9191 0.0201832 25.5265L0 25.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "translate(62 45)",
    id: "Path-23",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 11.2C6 12.7464 4.65685 14 3 14C1.46149 14 0.193479 12.9191 0.0201832 11.5265L0 11.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "translate(62 17)",
    id: "Path-23",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 25.2C6 26.7464 4.65685 28 3 28C1.46149 28 0.193479 26.9191 0.0201832 25.5265L0 25.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "matrix(-1 0 0 1 28 45)",
    id: "Path-23",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 11.2C6 12.7464 4.65685 14 3 14C1.46149 14 0.193479 12.9191 0.0201832 11.5265L0 11.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "matrix(-1 0 0 1 28 17)",
    id: "Path-23",
    fill: "#07A5DF",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 11.2C6 12.7464 4.65685 14 3 14C1.46149 14 0.193479 12.9191 0.0201832 11.5265L0 11.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "translate(50 51)",
    id: "Path-25-Copy",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 11.2C6 12.7464 4.65685 14 3 14C1.46149 14 0.193479 12.9191 0.0201832 11.5265L0 11.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "translate(34 51)",
    id: "Path-25-Copy-2",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 0C4.53851 0 5.80652 1.08091 5.97982 2.47346L6 2.8L6 11.2C6 12.7464 4.65685 14 3 14C1.46149 14 0.193479 12.9191 0.0201832 11.5265L0 11.2L0 2.8C0 1.2536 1.34315 0 3 0Z",
    transform: "translate(42 51)",
    id: "Path-25",
    fill: "#0B67B2",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(42 42)",
    id: "Oval",
    fill: "#0B67B2",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0L90 0L90 90L0 90L0 0Z",
    id: "Rectangle",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z",
    transform: "translate(56 5)",
    id: "Oval",
    fill: "#07A5DF",
    fillRule: "evenodd",
    stroke: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCh);
export default __webpack_public_path__ + "static/media/ch.81e522509c6cfdf1ebc31cf82ef7bd8c.svg";
export { ForwardRef as ReactComponent };